import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Icons
import { IoCubeOutline as CubeIcon } from "react-icons/io5";
import { TbPyramid as PyramidIcon } from "react-icons/tb";
import { IoDiamondOutline as DiamondIcon } from "react-icons/io5";
import { TbHexagonalPrism as PrismIcon } from "react-icons/tb";

// Other Projects SVG Logos
import { ReactComponent as LogoCC } from "../assets/svg/cc_logo.svg";
import { ReactComponent as LogoVOLAR } from "../assets/svg/volar_logo.svg";
// import racerImage from '../assets/images/racer.png';

const HomePage = () => {
  return (
    <div>
      <FirstSection />
      <WhatWeDoSection />
      <ProjectsSection />
      {/* <ContactForm /> */}
    </div>
  );
};

export default HomePage;

const FirstSection = () => {
  const { t } = useTranslation();

  return (
    <div
      id="home"
      className="relative min-h-screen h-fit w-full overflow-hidden font-rubik"
    >
      {/* <iframe
        src="https://www.youtube.com/embed/iFaMrK6MlxM?autoplay=1&mute=1&loop=1&playlist=iFaMrK6MlxM;controls=0"
        title="SecurityCode Intro (small)"
        allowFullScreen
        allow="autoplay; encrypted-media;"
        className="video-iframe"
      ></iframe> */}

      {/* Gradient Layer */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-800 to-slate-400 "></div>

      {/* Content */}
      <div className="absolute inset-0 flex flex-col justify-center items-start text-white p-[4vmin] md:p-[2.25vmin] lg:p-0 mt-[30vmin] md:mt-[14vmin] lg:mt-[21vmin] lg:mx-[7.5vw]">
        <h3 className="text-[6vmin] md:text-4xl text-slate-400 font-roboto">
          {t("homepage.subtitle")}
        </h3>
        <h1 className="text-[12vmin] md:text-[10vmin] font-bold leading-[12vmin] md:leading-[8.5vmin] mt-[6vmin] md:mt-[2.25vmin]">
          <span>{t("homepage.title1")}</span>
          <br />
          <span>{t("homepage.title2")}</span>
          <br />
          <span>{t("homepage.title3")}</span>
        </h1>

        <button
          className="px-[7vmin] md:px-14 py-[3vmin] md:py-5 text-white md:text-xl font-bold rounded-full transition duration-300 ease-in-out border-2 my-[10vmin] md:my-11 lg:my-11"
          style={{
            borderColor: "#00FF00",
          }}
          id="book_a_call"
          onClick={() =>
            window.open(
              "https://wa.me/593998028149?text=Saludos%21%20Deseo%20agendar%20una%20llamada.",
              "_blank"
            )
          }
        >
          {t("navigation.book_a_call")}
        </button>
      </div>
    </div>
  );
};

const WhatWeDoSection = () => {
  const { t } = useTranslation();

  return (
    <div className="relative text-black flex flex-col w-screen" id="what-we-do">
      {/* Background SVGs */}

      <div className="absolute inset-0 bg-gradient-to-b from-white to-slate-100 flex flex-col">
        <BGPropLeftSVG className="w-auto h-[20vmin] min-h-[200px] self-start mb-[30vmin] md:mb-10" />
        <BGPropRightSVG className="w-auto h-[20vmin] min-h-[200px] self-end mb-[10vmin] md:mb-10" />
        <BGProp2LeftSVG className="w-auto h-[20vmin] min-h-[200px] self-start mb-[30vmin] md:mb-10" />
      </div>

      {/* Content Section */}
      <div className="relative z-10 flex flex-col justify-start items-start flex-grow text-center px-[4vmin] md:px-[2.25vmin] lg:px-0 mt-[20vmin] md:mt-32 lg:mt-[12vmin] lg:mx-[8vw]">
        <h1 className="text-[9vmin] md:text-7xl font-extrabold mb-[4vmin] ">
          {t("what_we_do.title")}
        </h1>
        <p className="text-[5vmin] md:text-3xl mb-6 max-w-[900px] text-left font-light text-gray-700 ">
          {t("what_we_do.description")}
        </p>

        {/* Activity Cards */}
        <div className="flex flex-wrap justify-center gap-6 md:gap-8 mt-10 mb-10">
          <ActivityCard
            title={t("what_we_do.1_service_title")}
            description={t("what_we_do.1_service_desc")}
            icon="cube_icon"
            color="#FF3399"
            link={t("what_we_do.1_service_route_url")}
          />
          <ActivityCard
            title={t("what_we_do.2_service_title")}
            description={t("what_we_do.2_service_desc")}
            icon="pyramid_icon"
            color="#3399FF"
            link={t("what_we_do.2_service_route_url")}
          />
          <ActivityCard
            title={t("what_we_do.3_service_title")}
            description={t("what_we_do.3_service_desc")}
            icon="diamond_icon"
            color="#33FF99"
            link={t("what_we_do.3_service_route_url")}
          />
          <ActivityCard
            title={t("what_we_do.4_service_title")}
            description={t("what_we_do.4_service_desc")}
            icon="prism_icon"
            color="#FF9933"
            link={t("what_we_do.4_service_route_url")}
          />
        </div>
      </div>
    </div>
  );
};

const ActivityCard = ({ title, description, icon, color, link }) => {
  let IconComponent;

  switch (icon) {
    case "cube_icon":
      IconComponent = <CubeIcon size={64} />;
      break;
    case "pyramid_icon":
      IconComponent = <PyramidIcon size={64} />;
      break;
    case "diamond_icon":
      IconComponent = <DiamondIcon size={64} />;
      break;
    case "prism_icon":
      IconComponent = <PrismIcon size={64} />;
      break;
    default:
      IconComponent = <CubeIcon size={64} />;
  }

  return (
    // <Link to={link} className="block">
    // cursor-pointer
    <div className="block">
      <div className="bg-white shadow-lg rounded-2xl p-2 flex flex-col justify-between w-[90vmin] md:w-[70vmin] min-w-[150px] max-w-[500px] h-[80vmin] md:h-full max-h-[600px] transition duration-300 hover:shadow-xl">
        <div className="flex flex-col items-start text-left font-light pt-[2vmin] flex-grow">
          <div
            style={{ color: color }}
            className="pb-3 md:pb-[3.2vmin] px-[4vmin] md:px-[2vmin] pt-[6vmin] md:pt-[1.6vmin] "
          >
            {IconComponent}
          </div>
          <h3 className="text-[6vmin] md:text-4xl font-semibold mb-2 px-[4vmin] md:px-[2.25vmin]">
            {title}
          </h3>
          <p className="text-[4.5vmin] md:text-2xl px-[4vmin] md:px-[2.25vmin] text-gray-600">
            {description}
          </p>
          <div className="h-0 md:h-10"></div>
        </div>
      </div>
    </div>
    // </Link>
  );
};

const ProjectsSection = () => {
  const { t } = useTranslation();

  return (
    <div
      id="projects"
      className="text-black flex flex-col w-screen relative px-[4vmin] md:px-[2.25vmin] lg:px-0"
    >
      {/* Background SVGs */}
      <div className="absolute z-0 w-full h-full top-0 left-0 pointer-events-none">
        <div className="flex flex-col w-full h-full">
          <BGPropLeftSVG className="w-auto h-[30vmin] min-h-[200px] max-h-[500px] self-start mb-8 md:mb-10" />
          <BGPropRightSVG className="w-auto h-[30vmin] min-h-[200px] max-h-[500px] self-end mb-8 md:mb-10" />
          <BGProp2LeftSVG className="w-auto h-[30vmin] min-h-[200px] max-h-[500px] self-start mb-8 md:mb-10" />
        </div>
      </div>

      {/* Title */}
      <h1 className="relative z-10 text-[9vmin] md:text-7xl font-extrabold text-left mt-[20vmin] md:mt-32 lg:mt-[12vmin] mb-[8vmin] lg:mx-[8vw]">
        {t("projects.title")}
      </h1>

      {/* Project 1 */}
      <div className="relative z-10 flex flex-col md:flex-row lg:flex-row justify-between items-center flex-grow text-center md:mt-[7vmin] lg:mx-[8vw]">
        <div className="flex flex-col items-start lg:w-1/2 mb-8 text-left">
          <h2 className="text-[6vmin] md:text-[4vmin] font-thin text-black">
            {t("projects.project1.subtitle")}
          </h2>
          <h1 className="text-[6vmin] md:text-6xl lg:text-6xl font-extrabold text-pink-600 mb-[2vmin]">
            {t("projects.project1.title")}
          </h1>
          <p className="text-[5vmin] md:text-3xl font-light text-gray-700">
            {t("projects.project1.description")}
          </p>
        </div>
        <div className="lg:w-1/2 flex justify-center">
          <LogoCC
            className="h-auto w-[50vmin] md:w-80 "
            style={{ color: "transparent" }}
          />
        </div>
      </div>

      {/* Project 2 */}
      <div className="relative z-10 flex flex-col md:flex-row lg:flex-row justify-between items-center flex-grow text-center lg:mx-[8vw]">
        <div className="h-28 md:mt-[36vmin] "></div>

        <div className="lg:w-1/2 flex justify-center mb-6">
          <LogoVOLAR className="h-auto w-[50vmin] md:w-80 " />
        </div>

        <div className="flex flex-col items-end lg:w-1/2 mb-8 text-right">
          <h2 className="text-[6vmin] md:text-4xl font-thin text-black">
            {t("projects.project2.subtitle")}
          </h2>
          <h1 className="text-[6vmin] md:text-6xl lg:text-6xl font-extrabold text-black mb-[2vmin]">
            {t("projects.project2.title")}
          </h1>
          <p className="text-[5vmin] md:text-3xl font-light text-gray-700">
            {t("projects.project2.description")}
          </p>
        </div>
      </div>

      {/* <div className="relative z-10 flex flex-col md:flex-row lg:flex-row justify-between items-center flex-grow text-center">
        <div className="flex flex-col  lg:w-1/2 text-right">
          <h2 className="text-[6vmin] md:text-4xl font-bold text-black mb-2">
            {t("projects.project2.subtitle")}
          </h2>
          <h1 className="text-[6vmin] md:text-5xl lg:text-5xl font-extrabold text-black mb-6">
            {t("projects.project2.title")}
          </h1>
          <p className="text-[5vmin] md:text-3xl text-gray-900 ">
            {t("projects.project2.description")}
          </p>
          <div className="lg:w-1/2 flex justify-center ">
            <LogoVOLAR className="h-auto w-[45vmin] md:w-80 lg:w-60" />
          </div>
        </div>
      </div> */}
    </div>
  );
};

const ContactForm = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-gray-50 px-4">
      <div className="w-full max-w-xl p-8 bg-white shadow-md rounded-lg">
        <h1 className="text-3xl font-bold text-center mb-8">
          {t("contact_form.title")}
        </h1>

        <form className="space-y-6">
          {/* Name */}
          {t("contact_form.name_label")}
          <div>
            <label
              htmlFor="name"
              className="block text-lg font-medium text-gray-700"
            ></label>
            <input
              type="text"
              id="name"
              name="name"
              required
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500"
              placeholder=""
            />
          </div>

          {/* Email */}
          <div>
            <label
              htmlFor="email"
              className="block text-lg font-medium text-gray-700"
            >
              {t("contact_form.email_label")}
            </label>
            <input
              type="email"
              id="email"
              name="email"
              required
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500"
              placeholder=""
            />
          </div>

          {/* Budget Size */}
          <div>
            <label
              htmlFor="budget"
              className="block text-lg font-medium text-gray-700"
            >
              {/* Budget Size */}
              {t("contact_form.budget_size_label")}
            </label>
            <select
              id="budget"
              name="budget"
              required
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500"
            >
              <option value="">
                {t("contact_form.select_your_budget_size_label")}
              </option>
              <option value="less-than-10k"> 0 - $10,000</option>
              <option value="10k-50k">$10,000 - $50,000</option>
              <option value="50k-100k">$50,000 - $100,000</option>
              <option value="more-than-100k"> + $100,000</option>
            </select>
          </div>

          {/* Description */}
          <div>
            <label
              htmlFor="description"
              className="block text-lg font-medium text-gray-700"
            >
              {t("contact_form.project_description_label")}
            </label>
            <textarea
              id="description"
              name="description"
              required
              rows="4"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500"
              placeholder=""
            ></textarea>
          </div>

          {/* How did you hear about us */}
          <div>
            <label
              htmlFor="hearAboutUs"
              className="block text-lg font-medium text-gray-700"
            >
              {/* How did you hear about us? */}
              {t("contact_form.how_did_you_hear_about_us_label")}
            </label>
            <input
              type="text"
              id="hearAboutUs"
              name="hearAboutUs"
              required
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-pink-500 focus:border-pink-500"
              placeholder=""
            />
          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              className="w-full bg-pink-600 text-white font-bold py-3 px-4 rounded-md hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2"
            >
              {t("contact_form.submit_label")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

//     * - - - - - - - - - - - - - *
//   /  SVGs FOR WHAT WE DO SECTION  \
//  * - - - - - - - - - - - - - - - - *

const BGPropLeftSVG = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 152 367"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_205_444)">
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-342 560.556C-342 561.27 -341.619 561.931 -341 562.288C-340.381 562.645 -339.619 562.645 -339 562.288L150.489 279.621C150.566 279.576 150.64 279.527 150.71 279.473C151.197 279.098 151.489 278.514 151.489 277.889C151.489 277.889 151.489 277.889 151.489 277.889L151.489 89.4443C151.489 89.3997 151.487 89.3554 151.484 89.3113C151.467 89.0491 151.398 88.7965 151.286 88.5662C151.114 88.2145 150.84 87.9148 150.489 87.7123L-175.83 -100.732C-176.449 -101.089 -177.211 -101.09 -177.83 -100.732C-178.449 -100.375 -178.83 -99.7147 -178.83 -99.0002L-178.83 89.4443C-178.83 90.1587 -178.449 90.8189 -177.83 91.1762L-17.6714 183.666L-341 370.379C-341.619 370.737 -342 371.397 -342 372.111L-342 560.556ZM-13.672 185.975L-338 373.266L-338 557.091L145.49 277.889L-13.672 185.975ZM147.489 274.424L147.489 92.9091L-9.67269 183.666L147.489 274.424ZM145.49 89.4444L-13.672 181.356L-174.83 88.2897L-174.83 -95.5357L145.49 89.4444Z"
        fill="#524A82"
      />
      <path
        d="M-26.9996 175.5L40.2754 214.024"
        stroke="#F6D200"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_205_444">
        <rect width="152" height="367" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const BGPropRightSVG = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 437 660"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_205_441)">
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M163.161 188.444C163.161 189.162 163.544 189.825 164.165 190.184L324.32 282.671L0.999841 469.379C0.381128 469.737 0 470.397 0 471.111L8.34465e-06 659.556C8.37589e-06 660.27 0.381241 660.93 1.00009 661.288C1.61894 661.645 2.38137 661.645 3.00017 661.288L492.328 378.714C492.384 378.688 492.439 378.659 492.493 378.628C493.115 378.27 493.498 377.606 493.498 376.889L493.498 188.444C493.498 187.727 493.115 187.063 492.493 186.705L166.174 -1.7398C165.553 -2.09872 164.787 -2.09878 164.166 -1.73996C163.544 -1.38113 163.161 -0.717953 163.161 -0.000240326L163.161 188.444ZM487.481 188.449L167.179 3.47953V187.285L328.337 280.351L487.481 188.449ZM332.336 282.66L489.48 191.914V373.409L332.336 282.66ZM328.319 284.98L487.481 376.894L4.00001 656.091L4 472.266L328.319 284.98Z"
        fill="#524A82"
      />
      <path
        d="M128 587L201 544"
        stroke="#E7107E"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_205_441">
        <rect width="437" height="660" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const BGProp2LeftSVG = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 569 494"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_219_319)">
      <path
        opacity="0.1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M-94.7369 330.311C-95.3804 330.253 -95.9607 329.886 -96.2875 329.32L-284.732 3.00069C-285.089 2.38188 -285.089 1.61946 -284.732 1.0006C-284.375 0.38173 -283.715 0.000504818 -283 0.000504756L-94.5556 0.000488281C-93.8412 0.000488219 -93.181 0.381622 -92.8237 1.0003L0.733093 163.007L93.7123 2.00031C94.0696 1.38162 94.7299 1.00049 95.4443 1.00049L283.889 1.0005L283.922 1.00077C284 1.00206 284.077 1.00789 284.154 1.01809C284.764 1.09942 285.308 1.45892 285.621 2.00039L568.288 491.489C568.645 492.108 568.645 492.871 568.288 493.489C567.93 494.108 567.27 494.489 566.556 494.489L378.111 494.489C377.397 494.489 376.737 494.108 376.379 493.49L189.666 170.161L97.1762 330.32C96.8189 330.938 96.1587 331.319 95.4443 331.319H-93.0002C-93.7148 331.319 -94.375 330.938 -94.7323 330.319C-94.7338 330.317 -94.7354 330.314 -94.7369 330.311ZM-93.4891 326.167L-279.535 4.0005L-95.7102 4.00049L-1.57645 167.007L-93.4891 326.167ZM94.9553 326.167L187.356 166.161L95.4445 6.99953L3.04263 167.007L94.9553 326.167ZM0.733093 171.006L90.4244 326.319H-88.9582L0.733093 171.006ZM98.9091 5.00052L189.666 162.162L280.424 5.0005L98.9091 5.00052ZM283.889 6.99955L191.975 166.161L379.266 490.489L563.091 490.489L283.889 6.99955Z"
        fill="#524A82"
      />
    </g>
    <defs>
      <clipPath id="clip0_219_319">
        <rect width="569" height="494" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// Other SVGs
